import React from 'react';
import { Link } from 'react-router-dom';
import '../../style/Pagination.css';

const Pagination = ({ currentPage, totalPages, getLink, mainColor = '#4169E1' }) => {
    if (totalPages <= 1) return null;

    // Generate array of all page numbers
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    return (
        <div className="pagination-grid-container">
            {pages.map((page) => (
                <Link
                    key={page}
                    to={getLink(page)}
                    className={`pagination-grid-item ${page === currentPage ? 'active' : ''}`}
                    style={page === currentPage ? {
                        backgroundColor: mainColor,
                        borderColor: mainColor
                    } : {
                        color: mainColor
                    }}
                >
                    {page}
                </Link>
            ))}
        </div>
    );
};

export default Pagination;
